import { ref, onMounted, onUnmounted } from "vue";

export function useViewportUtilities() {
    let documentHeight = 0;
    let headerHeight = 0;
    let footerHeight = 0;
    let scrollOffset = 0;

    const screen: {
        vh: number;
        vw: number;
    } = {
        vh: 0,
        vw: 0,
    };

    onMounted(() => {
        if (!window.viewportUtilitiesListening) {
            window.viewportUtilitiesListening = true;

            calculateAll();

            window.addEventListener("resize", () => {
                calculateAll();
            });

            window.addEventListener("orientationchange", () => {
                calculateAll();
            });

            document.addEventListener("lazyloaded", function (e) {
                calculateDocumentHeight();
            });
        }
    });

    function calculateAll() {
        calculateScreenDimensions();
        calculateFooterHeight();
        calculateHeaderHeight();
        calculateDocumentHeight();
        scrollOffset = headerHeight;
    }

    function calculateScreenDimensions() {
        screen.vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        screen.vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    }

    function calculateFooterHeight() {
        const footer = document.getElementsByTagName("footer");

        if (footer.length > 0) {
            footerHeight = footer[0].clientHeight;
            document.documentElement.style.setProperty("--footerHeight", `${footerHeight}px`);
        }
    }

    function calculateHeaderHeight() {
        const header = document.getElementsByTagName("header");

        if (header.length > 0) {
            headerHeight = header[0].clientHeight;
            document.documentElement.style.setProperty("--headerHeight", `${headerHeight}px`);
        }
    }

    function calculateDocumentHeight() {
        const body = document.body,
            html = document.documentElement;

        documentHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    }

    return { documentHeight, headerHeight, footerHeight, scrollOffset, screen };
}
